/* card/sagas*/
import {
  select,
  all,
  fork,
  put,
  takeEvery,
  takeLatest,
  spawn,
} from "redux-saga/effects";
import { has, isNil, includes, isEmpty } from "ramda";
import { Card, CardActionTypes } from "./types";
import { fetch, save, drop } from "../../repo/card";
import {
  fetchRequest,
  fetchError,
  fetchSuccess,
  saveRequest,
  saveSuccess,
  saveError,
  deleteRequest,
  deleteSuccess,
  deleteError,
} from "./actions";
import { dirty } from "../session/actions";
import { Error, isAuthError } from "../";

function* handleFetch(action: ReturnType<typeof fetchRequest>) {
  try {
    const user = yield fetch(action.payload.id, action.payload.params);
    if (user.errors && !isEmpty(user.errors)) {
      if (isAuthError(user.errors)) {
        yield put(dirty());
      }
      yield put(fetchError(JSON.stringify(user.errors)));
    } else {
      yield put(fetchSuccess(user));
    }
  } catch (err) {
    yield put(fetchError(err));
  }
}

function* watchFetchRequest() {
  yield takeEvery(CardActionTypes.FETCH, handleFetch);
}

function* handleSave(action: ReturnType<typeof saveRequest>) {
  try {
    const user = yield save(action.payload.data);
    // we may still have an error
    // if so then we should yield error
    if (user.errors && !isEmpty(user.errors)) {
      if (isAuthError(user.errors)) {
        yield put(dirty());
      }
      yield put(saveError(JSON.stringify(user.errors)));
      action.payload.callback &&
        action.payload.callback(JSON.stringify(user.errors), null);
    } else {
      yield put(saveSuccess(user));
      action.payload.callback && action.payload.callback(null, user);
    }
  } catch (err) {
    yield put(saveError(err));
    action.payload.callback &&
      action.payload.callback("An error occurred while saving Card", null);
  }
}

function* watchSaveRequest() {
  yield takeEvery(CardActionTypes.SAVE_REQUEST, handleSave);
}

function* handleDelete(action: ReturnType<typeof deleteRequest>) {
  try {
    const dropResponse = yield drop(action.payload.id);

    if (dropResponse.errors && !isEmpty(dropResponse.errors)) {
      if (isAuthError(dropResponse.errors)) {
        yield put(dirty());
      }
      yield put(deleteError(JSON.stringify(dropResponse.errors)));
      action.payload.callback &&
        action.payload.callback(JSON.stringify(dropResponse.errors));
    } else {
      yield put(deleteSuccess());
      action.payload.callback && action.payload.callback(null);
      yield put(fetchRequest(null));
    }
  } catch (err) {
    yield put(deleteError(err));
    action.payload.callback && action.payload.callback(JSON.stringify(err));
  }
}

function* watchDeleteRequest() {
  yield takeLatest(CardActionTypes.DELETE_REQUEST, handleDelete);
}

export default function* cardSaga() {
  yield all([
    spawn(watchFetchRequest),
    spawn(watchSaveRequest),
    spawn(watchDeleteRequest),
  ]);
}
